
/**
 * @file http库axios封装的方法
 * @description 提供公用的工具 functions
 */
import axios from 'axios';
import { Toast } from 'antd-mobile';
import { tranform2UrlEncode } from './tools';

/**
 * 按照jquery的api封装的方法
 * 默认配置
 * TODO 可选：是否登录的拦截，loading框
 */
export function ajax(options = {}) {
  if (!options.url) {
    console.log('请填写接口地址');
    return false;
  }
  if (options.loading) {
    Toast.loading('加载中', 0);
  }
  let config = {
    method: options.type || 'post',
    url: options.url,
    headers: options.headers || {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    timeout: options.timeout || 30*1000,
    responsoType: options.dataType || 'json',
  };
  // success error data
  options.data = options.data || {};
  // 数据深拷贝，防止对原始数据的污染
  // webapp的所有接口均有_source_type = 'webapp'
  const isFileUpload = Object.values(options.data).some(value => value instanceof File);
  if (!isFileUpload) {
    options.data = {...JSON.parse(JSON.stringify(options.data)), _source_type: 'webapp'}; 
  }
  if (config.method === 'get' || config.method === 'GET') {
    config.params = options.data;
  } else if (config.method === 'post' || config.method === 'POST') {
    // 检查是否有文件对象
    const isFileUpload = Object.values(options.data).some(value => value instanceof File);
    if (isFileUpload) {
      // 使用 FormData 封装数据
      const formData = new FormData();
      for (const key in options.data) {
        if (options.data.hasOwnProperty(key)) {
          if (options.data[key] instanceof File) {
            formData.append(key, options.data[key]);
          } else {
            formData.append(key, JSON.stringify(options.data[key]));
          }
        }
      }
      config.data = formData;
    } else {
      config.data = options.data;
      config.transformRequest =  [(data, headers) => {
        return tranform2UrlEncode(data);
      }];
    }
  }
  return axios(config).then(function(res) {
    if (options.loading) {
      Toast.hide();
    }
    if (res.status == 200) {
      if (options.success) {
        options.success(res.data, res);
      }
    }
    if (options.complete) {
      options.complete(res.data, res);
    }
  }).catch(function (error) {
    if (options.loading) {
      Toast.hide();
    }
    console.log('回调处理错误', error);
    if (options.error) {
      options.error(error);
    } else {
      console.log('网络故障');
    }
    if (options.complete) {
      options.complete();
    }
  });
}
/**
 * TODO
 * 要写一个拦截器，如果接口返回什么就要调到登录页面
 */


// WEBPACK FOOTER //
// ./src/utils/http.jsx